@if (params.data?.asset_recovery_id) {
  <div class="flex items-center gap-1">
    {{ params.data.asset_recovery_id }}
    @if (params.data.is_shared) {
      <mat-icon class="text-success" matTooltip="Shared">check_circle</mat-icon>
    }
  </div>
} @else {
  Not Created
}
